module.exports = __webpack_public_path__ + "img/glasstype-multifocal.edc86b15.svg";